import axios from 'axios'
import { memberCalls2Url } from '@helpers'

const getCountries = () => {
    const url = memberCalls2Url({
        path: '/settings/countryV2/enable/all'
    })

    return axios.get(url)
}

const getCountryById = (countryId: string) => {
    const url = memberCalls2Url({
        path: `/settings/countryV2/${countryId}`
    })

    return axios.get(url)
}

const getCountryByCode = (countryCode: string) => {
    const url = memberCalls2Url({
        path: `/settings/countryV2/code/${countryCode}`
    })

    return axios.get(url)
}

export const countriesApi = {
    getCountries,
    getCountryById,
    getCountryByCode
}
